<template>
  <div class="support" :style="{width: overWidth + 'px'}"> 
    <div class="content">
      <h4>Contact us</h4>
      <ol>
        <li>1、Email:amber@penghuee.com</li>
        <li>2、Phone number:+8613522735654</li>
      </ol>
    </div>
  </div>
</template>


<script>

export default {
  name: 'support',
  data () {
    return {
      overWidth: document.documentElement.clientWidth,
      overHeight: document.documentElement.clientHeight,
      fontSize: 14
    }
  },
  watch: {
    overWidth (val) {
      this.overWidth = val
      this.setSize()
    }
  },
  methods: {
    getFontSize () {
      return this.overWidth / 320 * 12
    },
    setSize () {
      if (this.overWidth / this.overHeight > 0.7) { this.overWidth = this.overHeight * 0.7} 
      this.fontSize = this.getFontSize()
    }
  },
  mounted () {
    window.onresize = () => {
      this.overWidth = document.documentElement.clientWidth
      this.overHeight = document.documentElement.clientHeight
    }
  },
  created () {
    this.setSize()
  }
}
</script>

<style>
.support {
  width: 100%;
  height: auto;
  -webkit-user-select: none;
  user-select: none;
  color: #333;
  margin: auto;
}
.content {
  text-align: center;
  padding-top: 20px;
}
li {
  list-style: none;
  margin: 1em 0;
}
button, input {
  outline: none;
  border: none;
}
a {
  text-decoration: none;
  color: inherit;
}
h4 {
  font-size: 1.2em;
  margin-bottom: 1em;
  font-weight: 700;
}
</style>